import { createSlice } from '@reduxjs/toolkit';
import { getProfile } from './thunk';

export const initialState = {
	error: '',
	success: '',
	user: {},
	establishmentActive: null,
	establishmentActiveLoaded: false
};

const ProfileSlice = createSlice({
	name: 'Profile',
	initialState,
	reducers: {
		profileSuccess(state, action) {
			state.success = action.payload.status;
			state.user = action.payload.data;
		},
		profileError(state, action) {
			state.error = action.payload;
		},
		editProfileChange(state) {
			state = { ...state };
		},
		resetProfileFlagChange(state) {
			state.success = null;
		},
		setEstablishmentActive(state, action){
			state.establishmentActiveLoaded = true
			if(action.payload){
				state.establishmentActive = action.payload;
			}
		}
	},
	extraReducers: builder => {
		builder.addCase(getProfile.fulfilled, (state, action) => {
			state.user = action.payload;
		});
		builder.addCase(getProfile.pending, (state, action) => {});
		builder.addCase(getProfile.rejected, (state, action) => {
			state.user = {};
		});
	},
});

export const {
	profileSuccess,
	profileError,
	editProfileChange,
	resetProfileFlagChange,
	setEstablishmentActive
} = ProfileSlice.actions;

export default ProfileSlice.reducer;
